import React from "react";
import { Page } from "../../components/page/page";
import styles from "./ancestor.module.css";
import { ChooseButton } from "../../components/choose-button/choose-button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAncestor } from "../../store/stateSlice";

const options = [
  {
    value: "Yes, I sometimes communicate with them",
    icon: "🤩",
  },
  {
    value: "Rarely, but the idea is intriguing",
    icon: "🤓",
  },
  {
    value: "Never, I don't connect with the spirit realm",
    icon: "🙂",
  },
  {
    value: "Not sure",
    icon: "🤔",
  },
];

const AncestorPage = () => {
  const dispatch = useDispatch();
  return (
    <Page
      title="Do you feel connected to your ancestors or receive messages from spirits?"
      hideContinueButton={true}
      currentStep={10}
    >
      <ul className={styles.list}>
        {options.map((option, i) => (
          <li key={i}>
            <Link
              to="../lineage"
              onClick={() => dispatch(setAncestor(option.value))}
            >
              <ChooseButton icon={option.icon}>{option.value}</ChooseButton>
            </Link>
          </li>
        ))}
      </ul>
    </Page>
  );
};

export { AncestorPage };
